export const VALUES = {
  bodyLoadingSkeletonCount: 6,
}
